import gsap from 'gsap';


function related_news() {
    
    
    const related_news_block = document.querySelectorAll('[data-block="related-news"]');
    if (!related_news_block) { return; }


    related_news_block.forEach(block => {
        const container = block.querySelector('[data-name="related_news_title"]');
        const heading = block.querySelector('h2');
        const rightDiv = block.querySelector('[data-name="related_news_title_links"]');
        
        if (!heading || !rightDiv) return;

        // Get widths
        const headingWidth = heading.offsetWidth;
        const divWidth = rightDiv.offsetWidth;
        console.log(headingWidth, divWidth);
        // Get the line element
        const line = block.querySelector('[data-name="related_news_title_line"]');
        if (!line) {
            console.log('Line element not found');
            return;
        }

        // Calculate space between elements and set line width
        const spaceBetween = container.offsetWidth - (headingWidth + divWidth) - (37*2);
        line.style.width = `${spaceBetween}px`;
    });


    
   
}


export { related_news }; 